import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, gmTool } from "@/mixins/index";
import channelComMixins from "./mixins/channelComMixins";
import { totalSummaryCk, totalSummaryCkCurrency } from "@/api/dataPirate/channelData";
import * as echarts from "echarts";
export default {
  mixins: [tabulation, channelComMixins, gmTool],
  name: "accountSummaryDetails",
  data: function data() {
    return {
      hour: "01:00",
      searchData: {
        summary_flag: "d",
        date: ""
      },
      name: 'accountSummaryDetails',
      keyVersion: '_v2',
      // 图表渠道切换变量
      activeChartChannel: '',
      chartDataMap: {}
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    getDate: function getDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.searchData.date = date;
    },

    /**
     * 全天账号详情 star
     */
    searchClick: function searchClick() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isverification, res, reqFn, queryData, rawData, channelKeys, summaryData, _channelKeys;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isverification = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                // if(this.currencyClose && !this.searchData.currency_info){
                //   if(isverification){
                //     this.$message.error('请选择货币类型')
                //   }
                //   return
                // }
                _this.searchData.start_date = _this.searchData.date;
                _this.searchData.end_date = _this.searchData.date;
                _this.reqLoading = true;
                res = {
                  data: {}
                };
                _context.next = 7;
                return _this.getexchangeRate();

              case 7:
                if (_this.queryCurrency == 'VND') {
                  _this.screenList = _this.screenListVND;
                } else if (_this.queryCurrency == 'USD') {
                  _this.screenList = _this.screenListP;
                } else {
                  _this.screenList = _this.screenListP;
                }

                _this.tableDataList = _this.screenList;
                _this.screen = _this.screenList.map(function (i) {
                  return i.prop;
                }); // const storageKey = this.name + this.dataConvert() + this.keyVersion;
                // let dbres = await this.$DBControls.get(storageKey)
                // if(dbres && dbres.code == 500){
                //     this.searchClick()
                //     return
                //   }
                // if (dbres && ((this.$times.theDay() != this.searchData.start_date) && (this.$times.theDay() != this.searchData.end_date))) {
                //   res.data = dbres.content
                // } else {

                _this.reqLoading = true;
                reqFn = _this.currencyClose ? totalSummaryCkCurrency : totalSummaryCk;
                _context.next = 14;
                return reqFn(_objectSpread(_objectSpread({}, _this.searchData), _this.defaultData()));

              case 14:
                queryData = _context.sent;

                if (queryData.code == 200) {
                  // if ((this.$times.theDay() != this.searchData.start_date) && (this.$times.theDay() != this.searchData.end_date)) {
                  //   this.$DBControls.update(storageKey, queryData.data)
                  // }
                  res.data = queryData.data;
                } // }


                _this.reqLoading = false;
                rawData = res.data || {};
                _this.tableData = [];
                _this.chartDataMap = {};
                channelKeys = Object.keys(rawData);
                summaryData = null;
                channelKeys.forEach(function (chKey) {
                  if (chKey === '汇总') {
                    var item = _objectSpread({}, rawData[chKey]); // 汇率转换及数值格式化处理


                    item['register_recharge_device_amountexchange'] = Number(item['register_recharge_device_amount'] || 0) * _this.exchangeRate;
                    item['register_recharge_account_amountexchange'] = Number(item['register_recharge_account_amount'] || 0) * _this.exchangeRate;
                    item['account_recharge_amountexchange'] = Number(item['account_recharge_amount'] || 0) * _this.exchangeRate;

                    _this.processingListTow.forEach(function (pItem) {
                      item[pItem] = _this.isyjfmvnd() ? Number(item[pItem]) * 100 : item[pItem];
                    });

                    _this.processingList.forEach(function (pItem) {
                      item[pItem] = _this.$utils.conversion(item[pItem]).toFixed(2);
                    });

                    summaryData = _objectSpread({
                      channel_mark: item.channel_mark || '汇总',
                      channel_name: item.channel_name || '汇总',
                      hours: '/'
                    }, item);
                    return; // 跳过常规日期循环
                  }

                  var datesObj = rawData[chKey] || {};
                  var dateKeys = Object.keys(datesObj).sort(); // 按日期升序

                  var chName = chKey;
                  var channelDateList = [];
                  dateKeys.forEach(function (dKey) {
                    var item = _objectSpread({}, datesObj[dKey]);

                    if (item.channel_name) chName = item.channel_name; // 汇率转换及防御性数值处理

                    item['register_recharge_device_amountexchange'] = Number(item['register_recharge_device_amount'] || 0) * _this.exchangeRate;
                    item['register_recharge_account_amountexchange'] = Number(item['register_recharge_account_amount'] || 0) * _this.exchangeRate;
                    item['account_recharge_amountexchange'] = Number(item['account_recharge_amount'] || 0) * _this.exchangeRate;

                    _this.processingListTow.forEach(function (pItem) {
                      item[pItem] = _this.isyjfmvnd() ? Number(item[pItem]) * 100 : item[pItem];
                    });

                    _this.processingList.forEach(function (pItem) {
                      item[pItem] = _this.$utils.conversion(item[pItem]).toFixed(2);
                    });

                    var rowData = _objectSpread({
                      channel_mark: item.channel_mark || chKey,
                      channel_name: item.channel_name || chName,
                      hours: dKey
                    }, item);

                    _this.tableData.push(rowData);

                    channelDateList.push(rowData);
                  });
                  _this.chartDataMap[chKey] = channelDateList;
                });

                if (summaryData) {
                  _this.tableData.push(summaryData);
                } // 4. 设置默认选择的渠道图表


                if (_this.searchData.channel_list && _this.searchData.channel_list.length > 0) {
                  _this.activeChartChannel = _this.searchData.channel_list[0];
                } else {
                  // 2. 顶部没有选中时，默认选中后端接口/数据返回的第一条渠道
                  _channelKeys = Object.keys(rawData).filter(function (k) {
                    return k !== '汇总';
                  });

                  if (_channelKeys.length > 0) {
                    _this.activeChartChannel = _channelKeys[0];
                  } else if (_this.channelList.length > 0) {
                    _this.activeChartChannel = _this.channelList[0].channel_mark;
                  } else {
                    _this.activeChartChannel = '';
                  }
                }

                _this.geteChart();

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleChartChannelChange: function handleChartChannelChange() {
      this.geteChart();
    },
    geteChart: function geteChart() {
      var _this2 = this;

      var chartDom = document.getElementById("echartaccountSummaryDetails");

      if (this.echartaccountSummaryDetails != null && this.echartaccountSummaryDetails != "" && this.echartaccountSummaryDetails != undefined) {
        this.echartaccountSummaryDetails.dispose(); //销毁
      }

      this.echartaccountSummaryDetails = echarts.init(chartDom);
      var currentChartData = this.chartDataMap[this.activeChartChannel] || [];
      var series = [];
      this.screenList.forEach(function (item, index) {
        series.push({
          name: item.label,
          type: "bar",
          yAxisIndex: _this2.collectNum.findIndex(function (i) {
            return i == item.prop;
          }) > -1 ? 1 : 0,
          data: currentChartData.map(function (i) {
            return i[item.prop];
          }),
          smooth: true,
          barMaxWidth: "50",
          symbol: "none"
        });
      });
      var option;
      option = {
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "item",
          formatter: function formatter(params) {
            return "".concat(params.seriesName, ":").concat(params.value);
          }
        },
        legend: {
          width: "100%",
          icon: "circle",
          itemHeight: 12,
          bottom: "0%",
          itemWidth: 15,
          inactiveColor: "#666666",
          formatter: ["{a|{name}}"].join("\n"),
          textStyle: {
            fontSize: 12,
            lineHeight: 12,
            rich: {
              a: {
                width: 120,
                verticalAlign: "middle"
              }
            },
            padding: [0, 0, -2, -4] //[上、右、下、左]

          },
          selected: this.selected
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "18%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false
          },
          data: ["全天账号详情"]
        },
        yAxis: [{
          type: "value",
          splitLine: {
            lineStyle: {
              type: "dashed"
            }
          },
          splitNumber: 5,
          axisLabel: {
            formatter: function formatter(value, index) {
              if (value >= 10000) {
                return (value / 10000).toFixed(2) + "万";
              } else if (value >= 1000) {
                return value;
              } else {
                return value;
              }
            }
          }
        }, {
          type: "value",
          splitNumber: 5,
          splitLine: {
            lineStyle: {
              type: "dashed"
            }
          }
        }],
        series: series
      };
      option && this.echartaccountSummaryDetails.setOption(option, true);
      var that = this;
      this.echartaccountSummaryDetails.on("legendselectchanged", function (params) {
        that.selected = JSON.parse(JSON.stringify(params.selected));
      });
    },
    exportdata: function exportdata() {
      var columns = [{
        label: '渠道ID',
        prop: 'channel_mark'
      }, {
        label: '渠道名称',
        prop: 'channel_name'
      }, {
        label: '时间',
        prop: 'hours'
      }];
      this.tableDataList.forEach(function (item) {
        columns.push({
          label: item.label,
          prop: item.prop
        });
      });
      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: '全天账号详情'
      });
    }
    /**
     * 全天账号详情 end
     */

  }
};